/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2024
 */

import { Component } from 'llama'
import FaceDrawer from '../../common/FaceDrawer'
import FacePartSelector from './FacePartSelector'

export default class FacePartEyes extends Component {
  constructor (opt) {
    super({
      ...opt,
      html: () => `<div id="part-choice-eyebrows" class="part-choice four-cols"></div>
      <div id="part-choice-eyes" class="part-choice four-cols"></div>`
    })
  }

  init (params, path) {
    const { eventBus, context } = this

    const faceDrawer = new FaceDrawer()
    this.addChildren(
      params, path,

      new FacePartSelector({
        name: 'FacePartSelector:eyebrows',
        eventBus,
        context,
        box: 'part-choice-eyebrows',
        num: 4,
        draw (ctx, i) {
          faceDrawer.drawEyebrows(ctx, i, 1, 5, { left: -20, top: 10 })
        },
        shape: 'eyebrows',
        width: 60,
        height: 30
      }),

      new FacePartSelector({
        name: 'FacePartSelector:eyes',
        eventBus,
        context,
        box: 'part-choice-eyes',
        num: 4,
        draw (ctx, i) {
          faceDrawer.drawEyes(ctx, i, 1, 5, { left: -20, top: 10 })
        },
        shape: 'eyes',
        width: 60,
        height: 40
      })
    )
  }
}
